import { useTranslation } from "react-i18next";
import { Box, Text } from "theme-ui";
import type { JSX } from "react";
import { Spinner } from "packages/dsaui/src/components";

interface LoadingProps {
  fullscreen?: boolean;
}

const Loading = ({ fullscreen = false }: LoadingProps): JSX.Element => {
  const { t } = useTranslation();

  return fullscreen ? (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{ margin: "0 auto", textAlign: "center", width: 250 }}>
        <Text as="h3" sx={{ mb: 2 }}>
          {t("loading")}
        </Text>
        <Spinner />
      </Box>
    </Box>
  ) : (
    <Spinner />
  );
};

export default Loading;
